import { useContext } from 'react';
import { GlobalContext } from '../context';
import defaultLocale from '../locale';
var localeOptions = [{
  label: '简体中文',
  value: 'zh-CN'
}, {
  label: 'English',
  value: 'en-US'
}];
function useLocale(locale, propsLang) {
  var _a, _b;
  var _c = useContext(GlobalContext),
    globalLang = _c.lang,
    setLang = _c.setLang;
  var lang = propsLang || globalLang || '';
  var target = locale || defaultLocale;
  var localeLabel = (_a = localeOptions.find(function (el) {
    return el.value === lang;
  })) === null || _a === void 0 ? void 0 : _a.label;
  return {
    t: target[lang] || {},
    lang: lang,
    setLang: setLang,
    localeLabel: localeLabel,
    localeOptions: localeOptions,
    isDefaultLang: lang === ((_b = localeOptions[0]) === null || _b === void 0 ? void 0 : _b.value)
  };
}
export default useLocale;